import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { categories } from '../../func/skills.js'
import Skills from './skills.js'

import { addTagsSearch } from '../../func/skills.js'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const Content = styled.div`
  border-radius: 20px;
  transition: background-color 0.5s ease;
`

const Body = styled.div`
  padding: 40px 40px 40px 40px;
  width: 45vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > input {
    width: 80%;
  }
`

const ModifyIcon = styled.div`
  width: 70px;
  height: 70px;
  background: url('/assets/svg/modif.svg');
  position: absolute;
  top: 5px;
  right: 5px;
`

const Text = styled.div`
  font-size: 13px;
  color: rgb(108, 108, 108);
  margin: 5px 0;
  border-radius: 5px;
  padding: 10px;
  background: rgb(232, 232, 232);
  border: none;
  position: relative;
`

const IconWrapper = styled.div`
  height: 70px;
  width: 50px;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 9999;
  display: flex;
  justify-content: space-around;
`

const ValidIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/valid.svg');
`

const CloseIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/close.svg');
`
const RemoveIcon = styled.div`
  width: 40px;
  height: 40px;
  background: url('/assets/svg/remove.svg');
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto 0;
`

class UsersList extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      email: ''
    }
  }

  render() {
    console.log(this.props)
    return (
      <Wrapper>
        <IconWrapper>
          <CloseIcon onClick={this.props.hideUsers} />
        </IconWrapper>
        <Content>
          <Body>
            {this.props.users
              .sort((a, b) => {
                if (a.lastname < b.lastname) {
                  return -1
                }
                if (a.lastname > b.lastname) {
                  return 1
                }
                return 0
              })
              .map((item, i) => {
                return (
                  <Text key={i}>
                    <p>Nom: {item.lastname}</p>
                    <p>Prénom: {item.firstname}</p>
                    <p>Email: {item.email}</p>
                    <p>
                      Création:{' '}
                      {new Date(item.createdAt).toLocaleDateString('fr-FR', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>

                    <p>Adresse: {item.adress}</p>
                    <p>Tel: {item.tel}</p>
                    <p>Organisme: {item.company}</p>
                    <p>Fonction: {item.job}</p>
                    <RemoveIcon
                      onClick={() => this.props.deleteUser(item.id)}
                    />
                  </Text>
                )
              })}
          </Body>
        </Content>
      </Wrapper>
    )
  }
}

export default UsersList



// WEBPACK FOOTER //
// ./src/components/admin/usersList.js